import { useEffect, useReducer } from "react";

export interface MenuState {
  sideBarOpen: boolean;
  searchInput: string;
  activeSearch: string;
  categoryOpen: string | null;
}

export type MenuAction =
  | { type: "TOGGLE_SIDEBAR" }
  | { type: "SET_SEARCH_INPUT"; payload: string }
  | { type: "SET_ACTIVE_SEARCH"; payload: string }
  | { type: "SET_CATEGORY_OPEN"; payload: string | null };

function menuReducer(state: MenuState, action: MenuAction): MenuState {
  switch (action.type) {
    case "TOGGLE_SIDEBAR":
      return { ...state, sideBarOpen: !state.sideBarOpen };
    case "SET_SEARCH_INPUT":
      return { ...state, searchInput: action.payload };
    case "SET_ACTIVE_SEARCH":
      return { ...state, activeSearch: action.payload };
    case "SET_CATEGORY_OPEN":
      return { ...state, categoryOpen: action.payload };
    default:
      return state;
  }
}

export const useMenuState = (
  defaultSideBarOpen?: boolean,
  onSideBarToggle?: (e: boolean) => void,
) => {
  const initialState: MenuState = {
    sideBarOpen: defaultSideBarOpen || false,
    searchInput: "",
    activeSearch: "",
    categoryOpen: null,
  };

  const [state, dispatch] = useReducer(menuReducer, initialState);

  const actions = {
    toggleSidebar: () => dispatch({ type: "TOGGLE_SIDEBAR" }),
    setSearchInput: (value: string) =>
      dispatch({ type: "SET_SEARCH_INPUT", payload: value }),
    setActiveSearch: (value: string) =>
      dispatch({ type: "SET_ACTIVE_SEARCH", payload: value }),
    setCategoryOpen: (value: string | null) =>
      dispatch({ type: "SET_CATEGORY_OPEN", payload: value }),
  };

  useEffect(() => {
    if (state.searchInput || state.searchInput === "") {
      dispatch({ type: "SET_ACTIVE_SEARCH", payload: state.searchInput });
    }
  }, [state.searchInput]);

  useEffect(() => {
    onSideBarToggle?.(state.sideBarOpen);
  }, [state.sideBarOpen, onSideBarToggle]);

  return { state, actions };
};
